import {
  Accordion,
  CustomButton,
  filterOperatorValues,
  FORMAT_PATTERN,
  formatPhoneNumber,
  formatValueWithPattern,
  FormInput,
  REGEX,
  SvgChevronUp,
  TabInterface,
} from '@ui-kit'
import { useForm, UseFormRegister } from 'react-hook-form'
import {
  componentNames,
  CUSTOM_SEPERATOR,
  ENTITY_NAME,
  NAMESPACES,
} from '../../utils/constants'
import {
  formatDataObject,
  getEntityDataByEntityNameApiForFilter,
  GetEntityDataByNameIdFilter,
  hideLoader,
  showLoader,
} from '@app-store'
import DropdownFields from './DropDownFields'
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../utils/agent.store'
import { CONFIG_STRINGS } from '../../utils/strings'
import { RECORD_STATUS } from '../../constants/form.constants'
import { isMultipleRecords } from '../../utils/aws-connect.utils'
import { isEmpty } from 'lodash'

interface RequesterSearchFormProps {
  currentInteractionTab?: TabInterface
  isLookup?: boolean
  isLookupSearch?: boolean
  entityType: string
  organizationType?: { label: string; value: string }
  // entityDataPayload?: GetEntityDataByNameIdFilter {/* TODO will review later */}
  setEntityDataPayload: React.Dispatch<
    React.SetStateAction<
      | {
          payload: GetEntityDataByNameIdFilter
          fromSearch?: boolean
        }
      | undefined
    >
  >
  setRecordFieldsEntityDataPayload?: React.Dispatch<
    React.SetStateAction<
      | {
          payload: GetEntityDataByNameIdFilter
          fromSearch?: boolean
        }
      | undefined
    >
  >
  backToFirstPage?: boolean
  advancedFiltersData?: AdvancedSearchInfo
  setAdvancedFiltersData?: React.Dispatch<
    React.SetStateAction<AdvancedSearchInfo | undefined>
  >
  setFetchKey: React.Dispatch<React.SetStateAction<number>>
  tabIndex?: number
  isIncomingCall?: boolean
  triggerSearchButton?: boolean
  fromTask?: boolean
  isOriginInteraction?: boolean
}

interface RelatedEntity {
  select?: string[]
  filters: { criteria: formatDataObject[] }[]
  related_entities?: Record<string, RelatedEntity>
}

const RequesterSearchForm = ({
  isLookupSearch,
  currentInteractionTab,
  isLookup,
  entityType,
  organizationType,
  setEntityDataPayload,
  setFetchKey,
  tabIndex,
  setRecordFieldsEntityDataPayload,
  backToFirstPage,
  advancedFiltersData,
  setAdvancedFiltersData,
  isIncomingCall,
  triggerSearchButton,
  fromTask,
  isOriginInteraction,
}: RequesterSearchFormProps) => {
  const [isAdvancedSearch, setIsAdvancedSearch] = useState(
    advancedFiltersData?.isAdvancedSearch ?? isLookupSearch ?? false
  )
  const records = useAppSelector((state) => state?.awsCall?.associatedRecords)
  const multipleRecords = isEmpty(records) ? false : isMultipleRecords(records)
  const phoneNumber = useAppSelector(
    (state) => state?.awsCall?.incomingPhoneNumber
  )
  const showDefaultNumber = !isEmpty(records)
    ? isMultipleRecords(records)
    : false
  const searchPhone =
    showDefaultNumber && phoneNumber
      ? formatPhoneNumber(phoneNumber, FORMAT_PATTERN.PHONE_INPUT)
      : ''
  const defaultValues = getDefaultValues(
    entityType,
    backToFirstPage,
    advancedFiltersData?.data,
    isIncomingCall && isOriginInteraction
  ) as AllFieldsType
  const { register, handleSubmit, reset, control, getValues, watch, setValue } =
    useForm({
      defaultValues: defaultValues,
    })
  const dispatch = useAppDispatch()
  const watchValues = {
    services__id: watch('services__id') ?? null,
    case_type: watch('case_type') ?? null,
  }
  const [renderOnCondition, setRenderOnCondition] = useState<boolean>(false)
  const handleFilter = (
    field:
      | FieldDefinition<ProviderFieldsType>
      | FieldDefinition<PatientFieldsType>
      | FieldDefinition<ContactFieldsType>
      | FieldDefinition<CaseFieldsType>
      | FieldDefinition<OrganizationFieldsType>
      | FieldDefinition<PatientViewFieldsType>
      | FieldDefinition<ProviderViewFieldsType>
      | FieldDefinition<CaseViewFieldsType>
      | FieldDefinition<FacilitiesViewFieldsType>
      | undefined,
    value: string,
    criteria: formatDataObject[],
    key: string
  ) => {
    if (field?.filterType === 'BETWEEN') {
      const startDate = new Date(`${value}T00:00:00`)
      const endDate = new Date(`${value}T23:59:59`)
      const startDateUTC = startDate.toISOString()
      const endDateUTC = endDate.toISOString()
      criteria.push({
        field_name: key,
        operation: 'BETWEEN',
        values: [startDateUTC, endDateUTC],
      })
    } else {
      let val = value
      if (field?.isPhone) {
        val = '+1 ' + value.replace('+1', '').replace(/\D/g, '')
      }

      if (field?.pattern === FORMAT_PATTERN.ZIP_CODE) {
        val = value.replace(/\D/g, '')
      }
      criteria.push({
        field_name: key,
        operation: field?.filterType ?? 'LIKE',
        values:
          typeof value === 'string' &&
          value.includes(CUSTOM_SEPERATOR.SAFE_DELIMITER)
            ? val.split(CUSTOM_SEPERATOR.SAFE_DELIMITER)
            : [val],
      })
    }
  }

  const handleFilter2 = (
    field:
      | FieldDefinition<ProviderFieldsType>
      | FieldDefinition<PatientFieldsType>
      | FieldDefinition<ContactFieldsType>
      | FieldDefinition<CaseFieldsType>
      | FieldDefinition<OrganizationFieldsType>
      | FieldDefinition<PatientViewFieldsType>
      | FieldDefinition<ProviderViewFieldsType>
      | FieldDefinition<CaseViewFieldsType>
      | FieldDefinition<FacilitiesViewFieldsType>
      | undefined,
    originalEntity: RelatedEntity,
    value: string
  ) => {
    if (!field?.name) {
      return
    }
    const parts = field.name.split('__')
    let currentEntity: RelatedEntity = originalEntity
    let val = value

    if (field.isPhone) {
      val = '+1 ' + value.replace('+1', '').replace(/\D/g, '')
    }

    if (field?.pattern === FORMAT_PATTERN.ZIP_CODE) {
      val = value.replace(/\D/g, '')
    }

    for (let i = 0; i < parts.length - 1; i++) {
      const part = parts[i]
      currentEntity.related_entities ??= {}
      if (!currentEntity.related_entities?.[part]) {
        currentEntity['related_entities'][part] = {
          filters: [{ criteria: [] }],
          related_entities: {},
          select: [],
        }
      }

      currentEntity = currentEntity.related_entities[part]
    }
    const lastFieldName = parts[parts.length - 1]

    if (!currentEntity?.filters) {
      currentEntity['filters'] = [{ criteria: [] }]
    }

    currentEntity.filters[0].criteria.push({
      field_name: lastFieldName,
      operation: field.filterType ?? 'LIKE',
      values:
        typeof value === 'string' &&
        value.includes(CUSTOM_SEPERATOR.SAFE_DELIMITER)
          ? val.split(CUSTOM_SEPERATOR.SAFE_DELIMITER)
          : [val],
    })
    if (currentEntity?.select) currentEntity.select.push(lastFieldName)
  }

  const handleContactFields = async (
    data: typeof defaultValues,
    originalEntity: RelatedEntity
  ) => {
    if (data.patient__contact__first_name || data.patient__contact__last_name) {
      try {
        dispatch(showLoader())
        const payload = {
          entity_name: 'patient_relationship',
          select: ['patient', 'contact'],
          page: 0,
          size: 10000,
          related_entities: {
            contact: {
              select: ['first_name', 'last_name'],
              filters: [
                {
                  criteria: [] as formatDataObject[],
                },
              ],
            },
          },
        }
        if (data.patient__contact__first_name) {
          payload.related_entities.contact.filters[0].criteria.push({
            field_name: 'first_name',
            operation: 'LIKE',
            values: [data.patient__contact__first_name],
          })
        }
        if (data.patient__contact__last_name) {
          payload.related_entities.contact.filters[0].criteria.push({
            field_name: 'last_name',
            operation: 'LIKE',
            values: [data.patient__contact__last_name],
          })
        }
        const response = await getEntityDataByEntityNameApiForFilter({
          payload: payload,
        })
        const patientIds = response?.data?.content?.map(
          (item: { patient: { id: number } }) => item.patient.id.toString()
        )
        originalEntity.related_entities ??= {}
        if (!originalEntity.related_entities?.patient) {
          originalEntity.related_entities.patient = {
            filters: [{ criteria: [] }],
            related_entities: {},
            select: ['id'],
          }
        }
        originalEntity.related_entities.patient.filters[0].criteria.push({
          field_name: 'id',
          operation: filterOperatorValues.EQUALS,
          values: patientIds.length ? patientIds : ['-1'],
        })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoader())
      }
    }
  }

  const handleFacilityFields = async (
    data: typeof defaultValues,
    originalEntity: RelatedEntity
  ) => {
    if (
      data.c_facilities__c_facility_addresses_c_facilities__address_line_1 ||
      data.c_facilities__name
    ) {
      try {
        dispatch(showLoader())
        const payload = {
          entity_name: 'facilities',
          select: ['name', 'c_facility_addresses_c_facilities'],
          page: 0,
          size: 10000,
          related_entities: {
            c_facility_addresses_c_facilities: {
              select: ['address_line_1'],
              filters: [
                {
                  criteria: [] as formatDataObject[],
                },
              ],
            },
          },
          filters: [
            {
              criteria: [] as formatDataObject[],
            },
          ],
        }
        if (data.c_facilities__name) {
          payload.filters[0].criteria.push({
            field_name: 'name',
            operation: 'LIKE',
            values: [data.c_facilities__name],
          })
        }
        if (
          data.c_facilities__c_facility_addresses_c_facilities__address_line_1
        ) {
          payload.related_entities.c_facility_addresses_c_facilities.filters[0].criteria.push(
            {
              field_name: 'address_line_1',
              operation: 'LIKE',
              values: [
                data.c_facilities__c_facility_addresses_c_facilities__address_line_1,
              ],
            }
          )
        }
        const response = await getEntityDataByEntityNameApiForFilter({
          payload: payload,
        })
        const facilityIds = response?.data?.content?.map(
          (item: { id: number }) => item.id.toString()
        )
        originalEntity.related_entities ??= {}
        if (!originalEntity.related_entities?.c_facilities) {
          originalEntity.related_entities.c_facilities = {
            filters: [{ criteria: [] }],
            related_entities: {},
            select: ['id'],
          }
        }
        originalEntity.related_entities.c_facilities.filters[0].criteria.push({
          field_name: 'id',
          operation: filterOperatorValues.EQUALS,
          values: facilityIds.length ? facilityIds : ['-1'],
        })
      } catch (error) {
        console.log(error)
      } finally {
        dispatch(hideLoader())
      }
    }
  }
  const onReloadClick = () => {
    const values = getValues()
    onSearchClick(values)
  }
  const onSearchClick = async (data: typeof defaultValues) => {
    setAdvancedFiltersData?.((prev) => {
      return {
        ...prev,
        isAdvancedSearch: isAdvancedSearch,
        data: data,
      }
    })

    const selectKeys = new Set<string>()
    const originalEntity: RelatedEntity = { filters: [] }
    const criteria: formatDataObject[] = []
    Object.entries(data).forEach(([key, value]) => {
      if (
        key === 'patient__contact__first_name' ||
        key === 'patient__contact__last_name'
      ) {
        selectKeys.add('patient')
        return
      }
      if (
        key ===
          'c_facilities__c_facility_addresses_c_facilities__address_line_1' ||
        key === 'c_facilities__name'
      ) {
        selectKeys.add('c_facilities')
        return
      }
      const field = getFields(
        entityType,
        isIncomingCall && isOriginInteraction
      ).find((field) => field.name === key)
      if (field?.isMultiLookup) {
        if (value) selectKeys.add(key.split('__')[0])
      } else selectKeys.add(key.split('__')[0])
      if (value) {
        if (!field?.name?.includes('__')) {
          handleFilter(field, value, criteria, key)
        } else {
          handleFilter2(field, originalEntity, value)
        }
      }
    })
    await handleContactFields(data, originalEntity)
    await handleFacilityFields(data, originalEntity)

    let entityName = entityType.toLowerCase()
    if (
      entityName !== 'case' &&
      !CONFIG_STRINGS.ADVANCE_SEARCH_ENTITY_LABELS.includes(entityName ?? '')
    ) {
      entityName = entityName + 's'
    }

    const organizationTypeFilter = {
      organization_type: {
        filters: [
          {
            criteria: [
              {
                field_name: 'name',
                operation: 'LIKE',
                values: [String(organizationType?.label)],
              },
            ],
          },
        ],
      },
    }

    criteria.push({
      field_name: 'record_status',
      operation: filterOperatorValues.EQUALS,
      values: [RECORD_STATUS.ACTIVE],
    })

    const apiPayload = {
      entity_name: entityName,
      select: [
        ...Array.from(selectKeys).filter((val) => !val.includes('__')),
        ...(organizationTypeFilter ? ['organization_type'] : []),
      ],
      page: 0,
      size: 10,
      related_entities: {
        ...(originalEntity.related_entities || {}),
        ...(organizationType && organizationTypeFilter),
      },
      filters: [
        {
          criteria: criteria,
        },
      ],
    }
    setEntityDataPayload({ payload: { payload: apiPayload }, fromSearch: true })
    setRecordFieldsEntityDataPayload &&
      setRecordFieldsEntityDataPayload({
        payload: { payload: apiPayload },
        fromSearch: true,
      })
    setFetchKey((prev) => prev + 1)
  }

  const handlePatternChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    pattern: string
  ) => {
    const { value } = e.target
    const formattedValue = formatValueWithPattern(value, pattern)
    e.target.value = formattedValue
  }
  const basicFields = getFields(
    entityType,
    isIncomingCall && isOriginInteraction
  ).filter((field) => field.isBasic)
  const advancedFields = getFields(
    entityType,
    isIncomingCall && isOriginInteraction
  )

  const handleToggleSearchMode = () => {
    const currentValues = getValues()
    const basicFieldNames = basicFields.map((field) => field.name)
    const preservedValues = basicFieldNames.reduce((acc, fieldName) => {
      acc[fieldName] = currentValues[fieldName]
      return acc
    }, {} as Record<string, string | null>)
    if (!backToFirstPage) reset(preservedValues)
    setIsAdvancedSearch((prev) => !prev)
  }

  const renderFieldOnCondition = (
    entity: string,
    values: {
      services__id: string
      case_type: string
    }
  ): boolean => {
    switch (entity) {
      case ENTITY_NAME.CASE:
      case ENTITY_NAME.CASE_LOWER:
        if (values.case_type !== null) {
          setValue('enrollment_status__name', null)
          setValue('enrollment_end_date', null)
          setValue('enrollment_start_date', null)
        }
        if (values.services__id !== null) {
          setValue('c_pap_enrollment_details_case__enrollment_status_id', null)
          setValue('c_pap_enrollment_details_case__enrollment_start_date', null)
          setValue('c_pap_enrollment_details_case__enrollment_end_date', null)
        }
        return Boolean(
          values.services__id === '64' ||
            values.services__id === '63' ||
            values.case_type === 'PAP Appeal' ||
            values.case_type === 'Patient Assistance Program'
        )
      default:
        return false
    }
  }

  const getHeadingOnEntityType = (entity: string) => {
    switch (entity) {
      case ENTITY_NAME.FACILITY:
        return ENTITY_NAME.HEALTHCARE_FACILITY
      default:
        return entity
    }
  }

  useEffect(() => {
    window.addEventListener('custom-search-reload', () => {
      onReloadClick()
    })
    return () => {
      window.removeEventListener('custom-search-reload', onReloadClick)
    }
  }, [])

  useEffect(() => {
    if (isIncomingCall && isOriginInteraction) {
      if (currentInteractionTab?.key === ENTITY_NAME.PATIENTS) {
        setValue('c_patient_phones_c_patients__phone_number', searchPhone)
        setValue('c_provider_phones_c_providers__phone_number', null)
        setValue('c_contact_phones_contact__phone_number', null)
      }
      if (currentInteractionTab?.key === ENTITY_NAME.PROVDERS) {
        setValue('c_patient_phones_c_patients__phone_number', null)
        setValue('c_provider_phones_c_providers__phone_number', searchPhone)
        setValue('c_contact_phones_contact__phone_number', null)
      }
      if (currentInteractionTab?.key === ENTITY_NAME.CONTACTS) {
        setValue('c_patient_phones_c_patients__phone_number', null)
        setValue('c_provider_phones_c_providers__phone_number', null)
        setValue('c_contact_phones_contact__phone_number', searchPhone)
      }
      if (multipleRecords && isOriginInteraction) {
        const values = getValues()
        onSearchClick(values)
      }
    }
  }, [
    triggerSearchButton,
    multipleRecords,
    isAdvancedSearch,
    currentInteractionTab,
    isOriginInteraction,
    isIncomingCall,
  ])

  // useEffect(() => {
  //   if (isIncomingCall && isOriginInteraction) {
  //     if (currentInteractionTab?.key === ENTITY_NAME.PATIENTS) {
  //       setValue('c_patient_phones_c_patients__phone_number', searchPhone)
  //       setValue('c_provider_phones_c_providers__phone_number', null)
  //       setValue('c_contact_phones_contact__phone_number', null)
  //     }
  //     if (currentInteractionTab?.key === ENTITY_NAME.PROVDERS) {
  //       setValue('c_patient_phones_c_patients__phone_number', null)
  //       setValue('c_provider_phones_c_providers__phone_number', searchPhone)
  //       setValue('c_contact_phones_contact__phone_number', null)
  //     }
  //     if (currentInteractionTab?.key === ENTITY_NAME.CONTACTS) {
  //       setValue('c_patient_phones_c_patients__phone_number', null)
  //       setValue('c_provider_phones_c_providers__phone_number', null)
  //       setValue('c_contact_phones_contact__phone_number', searchPhone)
  //     }
  //   }
  // }, [isIncomingCall, currentInteractionTab, isOriginInteraction])

  useEffect(() => {
    const shouldRender = renderFieldOnCondition(
      entityType,
      watchValues as {
        services__id: string
        case_type: string
      }
    )

    setRenderOnCondition(shouldRender)
  }, [JSON.stringify(watchValues), entityType])

  if (!entityType) {
    return null
  }

  return (
    <form>
      {isLookup && !fromTask ? (
        <Accordion
          heading={
            'Search ' + getHeadingOnEntityType(entityType) + ' Information'
          }
          isDefaultActive={true}
        >
          <div className="p-3">
            <div
              className="grid gap-x-3 gap-y-4"
              style={{
                gridTemplateColumns:
                  'repeat(auto-fit, minmax(min(12rem, 25%), 1fr))',
              }}
            >
              {(isAdvancedSearch ? advancedFields : basicFields).map(
                (field, index) =>
                  field?.renderType &&
                  field?.renderType === NAMESPACES.CONDITIONAL_KEY &&
                  !renderOnCondition ? null : field.isDropdown ? (
                    <DropdownFields
                      key={`${field.name}-${index}`}
                      control={control}
                      label={field.label}
                      name={field.name}
                      api_name={field.api_name ?? ''}
                      embedded_name={field.embedded_name}
                      tabIndex={tabIndex ?? 0}
                      disabled={field.disabled ? !watch(field.disabled) : false}
                      selectedValue={
                        field.disabled && field.dependent
                          ? `${watch(field.disabled)},${watch(field.dependent)}`
                          : field.disabled
                          ? watch(field.disabled)
                          : undefined
                      }
                      filterBy={field?.filterBy}
                      uniqueValues={field?.uniqueValues}
                      setValue={setValue}
                      optionsBy={
                        field.optionsBy &&
                        field.optionsBy === NAMESPACES.LABEL_KEY
                          ? NAMESPACES.LABEL_KEY
                          : ''
                      }
                      isDependent={field.dependent ? true : false}
                      payload={field.payload}
                    />
                  ) : (
                    <FormInput
                      key={`${field.name}-${index}`}
                      dataQaId={`requestor-search-${entityType}-${field.name}`}
                      label={field.label}
                      name={field.name}
                      register={
                        field.regex && field.pattern
                          ? (((fieldName: typeof field.name) => {
                              const original = register(fieldName)
                              const result: typeof original = {
                                ...original,
                                onChange: async (e) => {
                                  handlePatternChange(
                                    e as React.ChangeEvent<HTMLInputElement>,
                                    field.pattern ?? ''
                                  )
                                  return original.onChange(e)
                                },
                              }
                              return result
                            }) as UseFormRegister<AllFieldsType>)
                          : register
                      }
                      type={field.type ?? 'text'}
                      tabIndex={tabIndex ?? 0}
                    />
                  )
              )}
            </div>
          </div>
        </Accordion>
      ) : (
        <div
          className="grid gap-x-3 gap-y-4"
          style={{
            gridTemplateColumns:
              'repeat(auto-fit, minmax(min(12rem, 25%), 1fr))',
          }}
        >
          {(isAdvancedSearch ? advancedFields : basicFields).map(
            (field, index) =>
              field?.renderType &&
              field?.renderType === NAMESPACES.CONDITIONAL_KEY &&
              !renderOnCondition ? null : field.isDropdown ? (
                <DropdownFields
                  key={`${field.name}-${index}`}
                  control={control}
                  label={field.label}
                  name={field.name}
                  api_name={field.api_name ?? ''}
                  embedded_name={field.embedded_name}
                  tabIndex={tabIndex ?? 0}
                  disabled={field.disabled ? !watch(field.disabled) : false}
                  selectedValue={
                    field.disabled && field.dependent
                      ? `${watch(field.disabled)},${watch(field.dependent)}`
                      : field.disabled
                      ? watch(field.disabled)
                      : undefined
                  }
                  filterBy={field?.filterBy}
                  uniqueValues={field?.uniqueValues}
                  setValue={setValue}
                  optionsBy={
                    field.optionsBy && field.optionsBy === NAMESPACES.LABEL_KEY
                      ? NAMESPACES.LABEL_KEY
                      : ''
                  }
                  isDependent={field.dependent ? true : false}
                  payload={field.payload}
                />
              ) : (
                <FormInput
                  key={`${field.name}-${index}`}
                  dataQaId={`requestor-search-${entityType}-${field.name}`}
                  label={field.label}
                  name={field.name}
                  register={
                    field.regex && field.pattern
                      ? (((fieldName: typeof field.name) => {
                          const original = register(fieldName)
                          const result: typeof original = {
                            ...original,
                            onChange: async (e) => {
                              handlePatternChange(
                                e as React.ChangeEvent<HTMLInputElement>,
                                field.pattern ?? ''
                              )
                              return original.onChange(e)
                            },
                          }
                          return result
                        }) as UseFormRegister<AllFieldsType>)
                      : register
                  }
                  type={field.type ?? 'text'}
                  tabIndex={tabIndex ?? 0}
                />
              )
          )}
        </div>
      )}

      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="text-blue-500 text-sm"
            onClick={handleToggleSearchMode}
          >
            {isAdvancedSearch
              ? NAMESPACES.BASIC_SEARCH
              : NAMESPACES.ADVANCED_SEARCH}
          </button>
          <span
            className={`transition-transform duration-500 ${
              isAdvancedSearch ? 'rotate-0' : 'rotate-180'
            }`}
          >
            <SvgChevronUp fill="#0A6FCD" height="5" width="10" />
          </span>
        </div>
        <div className="flex gap-3">
          <CustomButton
            dataQaId="requestor-clear-button"
            type="button"
            widthClass="w-[4.375rem]"
            height="h-[1.75rem]"
            className="text-xs"
            onClick={() => {
              reset(
                getDefaultValues(
                  entityType,
                  false,
                  undefined,
                  isIncomingCall && isOriginInteraction
                )
              )
            }}
            tabIndex={tabIndex}
          >
            {NAMESPACES.CLEAR}
          </CustomButton>
          <CustomButton
            dataQaId="requestor-search-button"
            type="button"
            color="primary"
            widthClass="w-[4.375rem]"
            height="h-[1.75rem]"
            className="text-xs"
            isFilled={true}
            tabIndex={tabIndex}
            onClick={handleSubmit(onSearchClick)}
          >
            {NAMESPACES.SEARCH}
          </CustomButton>
        </div>
      </div>
    </form>
  )
}

export default RequesterSearchForm

const getDefaultValues = (
  entityType: string,
  backToFirstPage?: boolean,
  advancedFiltersData?: AllFieldsType,
  isIncomingCall?: boolean
) => {
  if (backToFirstPage) {
    return advancedFiltersData ?? undefined
  }
  if (entityType === 'Provider') {
    if (isIncomingCall) {
      const fields: ProviderFieldsType = {
        provider_key: null,
        first_name: null,
        last_name: null,
        npi: null,
        c_provider_phones_c_providers__phone_number: null,
        email: null,
        preferred_name: null,
        tax_id: null,
        state_license_number: null,
        medicaid_ptan: null,
        specialty__id: null,
        external_id: null,
        legacy_id: null,
      }

      return fields
    }

    const fields: ProviderViewFieldsType = {
      'Provider ID': null,
      'First Name': null,
      'Last Name': null,
      'NPI Number': null,
      'Phone Number': null,
      'Fax Number': null,
      Email: null,
      'Preferred Name': null,
      'Tax ID': null,
      'State License Number': null,
      PTAN: null,
      Specialty: null,
      'External ID': null,
      'Legacy ID': null,
      created_at: null,
      created_by: null,
      modified_at: null,
      modified_by: null,
    }
    return fields
  } else if (entityType === 'Patient') {
    if (isIncomingCall) {
      const fields: PatientFieldsType = {
        patient_key: null,
        first_name: null,
        last_name: null,
        preferred_name: null,
        date_of_birth: null,
        ssn: null,
        email: null,
        c_patient_addresses_c_patients__address_line_1: null,
        c_patient_addresses_c_patients__zip_code: null,
        c_patient_addresses_c_patients__city: null,
        c_patient_addresses_c_patients__state_id: null,
        external_id: null,
        legacy_id: null,
        c_patient_phones_c_patients__phone_number: null,
        c_pap_enrollment_details_patient__enrollment_status_id: null,
        c_pap_enrollment_details_patient__enrollment_start_date: null,
        c_pap_enrollment_details_patient__enrollment_end_date: null,
      }
      return fields
    }
    const fields: PatientViewFieldsType = {
      'Patient ID': null,
      'First Name': null,
      'Last Name': null,
      'Date of Birth': null,
      SSN: null,
      'Phone Number': null,
      'Preferred Name': null,
      'Email Address': null,
      'Address Line 1': null,
      'Zip Code': null,
      City: null,
      State: null,
      external_id: null,
      'Legacy ID': null,
      created_at: null,
      created_by: null,
      modified_at: null,
      modified_by: null,
      enrollment_status__name: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
    }
    return fields
  } else if (entityType === 'Contact') {
    const fields: ContactFieldsType = {
      contact_key: null,
      contact_type__value: null,
      first_name: null,
      last_name: null,
      preferred_name: null,
      date_of_birth: null,
      c_contact_phones_contact__phone_number: null,
      email: null,
      c_contact_addresses_contact__address_line_1: null,
      c_contact_addresses_contact__zip_code: null,
      c_contact_addresses_contact__city: null,
      c_contact_addresses_contact__state__id: null,
      external_id: null,
      legacy_id: null,
    }
    return fields
  } else if (entityType === 'Case') {
    if (isIncomingCall) {
      const fields: CaseFieldsType = {
        case_key: null,
        products__id: null,
        services__id: null,
        c_sub_services__name: null,
        users__id: null,
        c_case_statuses__overall_case_status: null,
        case_status_id: null,
        intake_channel_id: null,
        case_summary__outcome_id: null,
        case_summary__outcome_reason_id: null,
        created_at: null,
        case_start_date: null,
        case_completion_date: null,
        modified_at: null,
        modified_by: null,
        legacy_id: null,
        patient: null,
        provider: null,
        healthcareFacility: null,
        contact: null,
        requestor: null,
        c_case_insurances_c_cases__payer_id: null,
        patient__first_name: null,
        patient__last_name: null,
        patient__date_of_birth: null,
        c_provider__first_name: null,
        c_provider__last_name: null,
        c_provider__npi: null,
        patient__contact__first_name: null,
        patient__contact__last_name: null,
        requestor__first_name: null,
        requestor__last_name: null,
        c_facilities__name: null,
        c_facilities__c_facility_addresses_c_facilities__address_line_1: null,
        c_pap_enrollment_details_case__enrollment_status_id: null,
        c_pap_enrollment_details_case__enrollment_start_date: null,
        c_pap_enrollment_details_case__enrollment_end_date: null,
      }
      return fields
    }
    const fields: CaseViewFieldsType = {
      case_id: null,
      program: null,
      product: null,
      channel: null,
      case_type: null,
      case_subtype: null,
      assignee: null,
      overall_case_status: null,
      case_status: null,
      outcome: null,
      outcome_reason: null,
      requestor_first_name: null,
      requestor_last_name: null,
      requestor_phone_number: null,
      requestor_fax_number: null,
      patient_first_name: null,
      patient_last_name: null,
      patient_dob: null,
      patient_phone_number: null,
      patient_fax_number: null,
      provider_first_name: null,
      provider_last_name: null,
      provider_phone_number: null,
      provider_fax_number: null,
      provider_npi: null,
      healthcare_facility_name: null,
      healthcare_facility_address_line_1: null,
      healthcare_facility_phone_number: null,
      healthcare_facility_fax_number: null,
      payer: null,
      request_received_at: null,
      case_start_date: null,
      legacy_id: null,
      created_at: null,
      created_by: null,
      modified_at: null,
      modified_by: null,
      enrollment_status__name: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
    }
    return fields
  } else if (entityType === 'Facility') {
    const fields: FacilitiesViewFieldsType = {
      'Facility ID': null,
      'Facility Type': null,
      'Facility Name': null,
      'Phone Number': null,
      'Fax Number': null,
      global_address_line_1: null,
      global_address_line_2: null,
      global_address_city: null,
      global_address_state: null,
      global_address_zip: null,
      Email: null,
      Website: null,
      NPI: null,
      'Tax ID': null,
      NCPDP: null,
      'External ID': null,
      'Legacy ID': null,
      created_at: null,
      created_by: null,
      modified_at: null,
      modified_by: null,
    }
    return fields
  } else if (entityType === 'Organization') {
    const fields: OrganizationFieldsType = {
      organization_key: null,
      organization_sub_type__id: null,
      name: null,
      c_organization_phones_organization__phone_number: null,
      email: null,
      website: null,
      npi: null,
      tax_id: null,
      ncpdp: null,
      external_id: null,
      legacy_id: null,
    }
    return fields
  }
  return undefined
}

export interface AdvancedSearchInfo {
  data: AllFieldsType
  isAdvancedSearch: boolean
}

export interface AllFieldsType
  extends ProviderFieldsType,
    PatientFieldsType,
    ContactFieldsType,
    CaseFieldsType,
    OrganizationFieldsType,
    PatientViewFieldsType,
    ProviderViewFieldsType,
    CaseViewFieldsType,
    FacilitiesViewFieldsType {}

interface ProviderFieldsType {
  provider_key: string | null
  first_name: string | null
  last_name: string | null
  npi: string | null
  c_provider_phones_c_providers__phone_number: string | null
  email: string | null
  preferred_name: string | null
  tax_id: string | null
  state_license_number: string | null
  medicaid_ptan: string | null
  specialty__id: string | null
  external_id: string | null
  legacy_id: string | null
}

interface PatientFieldsType {
  patient_key: string | null
  first_name: string | null
  last_name: string | null
  preferred_name: string | null
  date_of_birth: string | null
  ssn: string | null
  email: string | null
  c_patient_addresses_c_patients__address_line_1: string | null
  c_patient_addresses_c_patients__zip_code: string | null
  c_patient_addresses_c_patients__city: string | null
  c_patient_addresses_c_patients__state_id: string | null
  external_id: string | null
  legacy_id: string | null
  c_patient_phones_c_patients__phone_number: string | null
  c_pap_enrollment_details_patient__enrollment_status_id: string | null
  c_pap_enrollment_details_patient__enrollment_start_date: string | null
  c_pap_enrollment_details_patient__enrollment_end_date: string | null
}

interface PatientViewFieldsType {
  'Patient ID': string | null
  'First Name': string | null
  'Last Name': string | null
  'Date of Birth': string | null
  SSN: string | null
  'Phone Number': string | null
  'Preferred Name': string | null
  'Email Address': string | null
  'Address Line 1': string | null
  'Zip Code': string | null
  City: string | null
  State: string | null
  external_id: string | null
  'Legacy ID': string | null
  created_at: string | null
  created_by: string | null
  modified_at: string | null
  modified_by: string | null
  enrollment_status__name: string | null
  enrollment_start_date: string | null
  enrollment_end_date: string | null
}

interface ProviderViewFieldsType {
  'Provider ID': string | null
  'First Name': string | null
  'Last Name': string | null
  'NPI Number': string | null
  'Phone Number': string | null
  'Fax Number': string | null
  Email: string | null
  'Preferred Name': string | null
  'Tax ID': string | null
  'State License Number': string | null
  PTAN: string | null
  Specialty: string | null
  'External ID': string | null
  'Legacy ID': string | null
  created_at: string | null
  created_by: string | null
  modified_at: string | null
  modified_by: string | null
}

interface ContactFieldsType {
  contact_key: string | null
  contact_type__value: string | null
  first_name: string | null
  last_name: string | null
  preferred_name: string | null
  date_of_birth: string | null
  c_contact_phones_contact__phone_number: string | null
  email: string | null
  c_contact_addresses_contact__address_line_1: string | null
  c_contact_addresses_contact__zip_code: string | null
  c_contact_addresses_contact__city: string | null
  c_contact_addresses_contact__state__id: string | null
  external_id: string | null
  legacy_id: string | null
}

interface CaseFieldsType {
  case_key: string | null
  products__id: string | null
  services__id: string | null
  c_sub_services__name: string | null
  users__id: string | null
  c_case_statuses__overall_case_status: string | null
  case_status_id: string | null
  intake_channel_id: string | null
  case_summary__outcome_id: string | null
  case_summary__outcome_reason_id: string | null
  created_at: string | null
  case_start_date: string | null
  case_completion_date: string | null
  modified_at: string | null
  modified_by: string | null
  legacy_id: string | null
  patient: string | null
  provider: string | null
  healthcareFacility: string | null
  contact: string | null
  requestor: string | null
  c_case_insurances_c_cases__payer_id: string | null
  patient__first_name: string | null
  patient__last_name: string | null
  patient__date_of_birth: string | null
  c_provider__first_name: string | null
  c_provider__last_name: string | null
  c_provider__npi: string | null
  patient__contact__first_name: string | null
  patient__contact__last_name: string | null
  requestor__first_name: string | null
  requestor__last_name: string | null
  c_facilities__name: string | null
  c_facilities__c_facility_addresses_c_facilities__address_line_1: string | null
  c_pap_enrollment_details_case__enrollment_status_id: string | null
  c_pap_enrollment_details_case__enrollment_start_date: string | null
  c_pap_enrollment_details_case__enrollment_end_date: string | null
}

interface CaseViewFieldsType {
  case_id: string | null
  program: string | null
  product: string | null
  channel: string | null
  case_type: string | null
  case_subtype: string | null
  assignee: string | null
  overall_case_status: string | null
  case_status: string | null
  outcome: string | null
  outcome_reason: string | null
  requestor_first_name: string | null
  requestor_last_name: string | null
  requestor_phone_number: string | null
  requestor_fax_number: string | null
  patient_first_name: string | null
  patient_last_name: string | null
  patient_dob: string | null
  patient_phone_number: string | null
  patient_fax_number: string | null
  provider_first_name: string | null
  provider_last_name: string | null
  provider_phone_number: string | null
  provider_fax_number: string | null
  provider_npi: string | null
  healthcare_facility_name: string | null
  healthcare_facility_address_line_1: string | null
  healthcare_facility_phone_number: string | null
  healthcare_facility_fax_number: string | null
  payer: string | null
  request_received_at: string | null
  case_start_date: string | null
  legacy_id: string | null
  created_at: string | null
  created_by: string | null
  modified_at: string | null
  modified_by: string | null
  enrollment_status__name: string | null
  enrollment_start_date: string | null
  enrollment_end_date: string | null
}

interface OrganizationFieldsType {
  organization_key: string | null
  organization_sub_type__id: string | null
  name: string | null
  c_organization_phones_organization__phone_number: string | null
  email: string | null
  website: string | null
  npi: string | null
  tax_id: string | null
  ncpdp: string | null
  external_id: string | null
  legacy_id: string | null
}

interface FacilitiesViewFieldsType {
  'Facility ID': string | null
  'Facility Type': string | null
  'Facility Name': string | null
  'Phone Number': string | null
  'Fax Number': string | null
  global_address_line_1: string | null
  global_address_line_2: string | null
  global_address_city: string | null
  global_address_state: string | null
  global_address_zip: string | null
  Email: string | null
  Website: string | null
  NPI: string | null
  'Tax ID': string | null
  NCPDP: string | null
  'External ID': string | null
  'Legacy ID': string | null
  created_at: string | null
  created_by: string | null
  modified_at: string | null
  modified_by: string | null
}

const ProviderFields: FieldDefinition<ProviderFieldsType>[] = [
  {
    name: 'provider_key',
    label: 'Provider ID',
    isBasic: true,
  },
  {
    name: 'first_name',
    label: 'First Name',
    isBasic: true,
  },
  {
    name: 'last_name',
    label: 'Last Name',
    isBasic: true,
  },
  {
    name: 'npi',
    label: 'NPI number',
    isBasic: true,
  },
  {
    name: 'c_provider_phones_c_providers__phone_number',
    label: 'Phone/Fax Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'email',
    label: 'Email Address',
  },
  {
    name: 'preferred_name',
    label: 'Preferred Name',
  },
  {
    name: 'tax_id',
    label: 'Tax ID',
  },
  {
    name: 'state_license_number',
    label: 'State License Number',
  },
  {
    name: 'medicaid_ptan',
    label: 'PTAN (Medicare)',
  },
  {
    name: 'specialty__id',
    label: 'Provider Specialty',
    isDropdown: true,
    api_name: componentNames.CATEGORY,
    embedded_name: 'Speciality',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'external_id',
    label: 'External ID',
  },
  {
    name: 'legacy_id',
    label: 'Legacy ID',
  },
]

const ProviderViewFields: FieldDefinition<ProviderViewFieldsType>[] = [
  {
    name: 'Provider ID',
    label: 'Provider ID',
    isBasic: true,
  },
  {
    name: 'First Name',
    label: 'First Name',
    isBasic: true,
  },
  {
    name: 'Last Name',
    label: 'Last Name',
    isBasic: true,
  },
  {
    name: 'NPI Number',
    label: 'NPI number',
    isBasic: true,
  },
  {
    name: 'Phone Number',
    label: 'Phone Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'Fax Number',
    label: 'Fax Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
  },
  {
    name: 'Email',
    label: 'Email',
  },
  {
    name: 'Preferred Name',
    label: 'Preferred Name',
  },
  {
    name: 'Tax ID',
    label: 'Tax ID',
  },
  {
    name: 'State License Number',
    label: 'State License Number',
  },
  {
    name: 'PTAN',
    label: 'PTAN',
  },
  {
    name: 'Specialty',
    label: 'Provider Specialty',
    isDropdown: true,
    api_name: componentNames.CATEGORY,
    embedded_name: 'Speciality',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'External ID',
    label: 'External ID',
  },
  {
    name: 'Legacy ID',
    label: 'Legacy ID',
  },
  {
    name: 'created_at',
    label: 'Created At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'created_by',
    label: 'Created By',
  },
  {
    name: 'modified_at',
    label: 'Modified At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'modified_by',
    label: 'Modified By',
  },
]

const PatientFields: FieldDefinition<PatientFieldsType>[] = [
  {
    name: 'patient_key',
    label: 'Patient ID',
    isBasic: true,
  },
  {
    name: 'first_name',
    label: 'First Name',
    isBasic: true,
  },
  {
    name: 'last_name',
    label: 'Last Name',
    isBasic: true,
  },
  {
    name: 'date_of_birth',
    label: 'Date of Birth',
    type: 'date',
    isBasic: true,
  },
  {
    name: 'ssn',
    label: 'Last 4 Digits of SSN',
    pattern: FORMAT_PATTERN.LAST_4_DIGIT_SSN,
    regex: REGEX.LAST_4_DIGIT_SSN,
  },
  {
    name: 'c_patient_phones_c_patients__phone_number',
    label: 'Phone Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'preferred_name',
    label: 'Preferred Name',
  },
  {
    name: 'email',
    label: 'Email Address',
  },
  {
    name: 'c_pap_enrollment_details_patient__enrollment_status_id',
    label: 'Enrollment Status',
    isDropdown: true,
    filterType: 'EQUALS',
    api_name: 'pap_enrollment_statuses',
  },
  {
    name: 'c_pap_enrollment_details_patient__enrollment_start_date',
    label: 'Enrollment Start Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'c_pap_enrollment_details_patient__enrollment_end_date',
    label: 'Enrollment End Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'c_patient_addresses_c_patients__address_line_1',
    label: 'Address Line 1',
    isMultiLookup: true,
  },
  {
    name: 'c_patient_addresses_c_patients__zip_code',
    label: 'Zip Code',
    filterType: filterOperatorValues.EQUALS,
    isMultiLookup: true,
    type: 'number',
  },
  {
    name: 'c_patient_addresses_c_patients__city',
    label: 'City',
    isMultiLookup: true,
  },
  {
    name: 'c_patient_addresses_c_patients__state_id',
    label: 'State',
    isMultiLookup: true,
    isDropdown: true,
    api_name: 'states',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'external_id',
    label: 'External ID',
  },
  {
    name: 'legacy_id',
    label: 'Legacy ID',
  },
]

const PatientViewFields: FieldDefinition<PatientViewFieldsType>[] = [
  {
    name: 'Patient ID',
    label: 'Patient ID',
    isBasic: true,
  },
  {
    name: 'First Name',
    label: 'First Name',
    isBasic: true,
  },
  {
    name: 'Last Name',
    label: 'Last Name',
    isBasic: true,
  },
  {
    name: 'Date of Birth',
    label: 'Date of Birth',
    type: 'date',
    isBasic: true,
  },
  {
    name: 'SSN',
    label: 'Last 4 Digits of SSN',
    pattern: FORMAT_PATTERN.LAST_4_DIGIT_SSN,
    regex: REGEX.LAST_4_DIGIT_SSN,
  },
  {
    name: 'Phone Number',
    label: 'Phone Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'Preferred Name',
    label: 'Preferred Name',
  },
  {
    name: 'Email Address',
    label: 'Email Address',
  },
  {
    name: 'enrollment_status__name',
    label: 'Enrollment Status',
    isDropdown: true,
    api_name: 'pap_enrollment_statuses',
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'enrollment_start_date',
    label: 'Enrollment Start Date',
    type: 'date',
  },
  {
    name: 'enrollment_end_date',
    label: 'Enrollment End Date',
    type: 'date',
  },
  {
    name: 'Address Line 1',
    label: 'Address Line 1',
    isMultiLookup: true,
  },
  {
    name: 'Zip Code',
    label: 'Zip Code',
    filterType: filterOperatorValues.EQUALS,
    isMultiLookup: true,
    type: 'number',
  },
  {
    name: 'City',
    label: 'City',
    isMultiLookup: true,
  },
  {
    name: 'State',
    label: 'State',
    isMultiLookup: true,
    isDropdown: true,
    api_name: 'states',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'external_id',
    label: 'External ID',
  },
  {
    name: 'Legacy ID',
    label: 'Legacy ID',
  },
  {
    name: 'created_at',
    label: 'Created At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'created_by',
    label: 'Created By',
  },
  {
    name: 'modified_at',
    label: 'Modified At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'modified_by',
    label: 'Modified By',
  },
]

const ContactFields: FieldDefinition<ContactFieldsType>[] = [
  {
    name: 'contact_key',
    label: 'Contact ID',
    isBasic: true,
  },
  {
    name: 'first_name',
    label: 'First Name',
    isBasic: true,
  },
  {
    name: 'last_name',
    label: 'Last Name',
    isBasic: true,
  },
  {
    name: 'date_of_birth',
    label: 'Date Of Birth',
    type: 'date',
  },
  {
    name: 'contact_type__value',
    label: 'Person Sub Type',
  },
  {
    name: 'preferred_name',
    label: 'Preferred Name',
  },
  {
    name: 'c_contact_phones_contact__phone_number',
    label: 'Phone/Fax Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isBasic: true,
  },
  {
    name: 'email',
    label: 'Email Address',
  },
  {
    name: 'c_contact_addresses_contact__address_line_1',
    label: 'Address Line 1',
  },
  {
    name: 'c_contact_addresses_contact__zip_code',
    label: 'Zip Code',
  },
  {
    name: 'c_contact_addresses_contact__city',
    label: 'City',
  },
  {
    name: 'c_contact_addresses_contact__state__id',
    label: 'State',
    isDropdown: true,
    api_name: 'states',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'external_id',
    label: 'External ID',
  },
  {
    name: 'legacy_id',
    label: 'Legacy ID',
  },
]

const CaseFields: FieldDefinition<CaseFieldsType>[] = [
  {
    name: 'case_key',
    label: 'Case ID',
    isBasic: true,
  },
  {
    name: 'products__id',
    label: 'Product',
    isDropdown: true,
    api_name: 'products',
    embedded_name: 'trademarked_name',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'services__id',
    label: 'Case Type',
    isDropdown: true,
    api_name: 'services',
    embedded_name: 'service_name',
    isBasic: true,
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'c_sub_services__name',
    label: 'Case Subtype',
    isDropdown: true,
    api_name: 'sub_services',
    isBasic: true,
    filterType: filterOperatorValues.EQUALS,
    uniqueValues: true,
  },
  {
    name: 'c_pap_enrollment_details_case__enrollment_status_id',
    label: 'Enrollment Status',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    isDropdown: true,
    api_name: 'pap_enrollment_statuses',
    filterType: filterOperatorValues.EQUALS,
    isBasic: true,
  },
  {
    name: 'c_pap_enrollment_details_case__enrollment_start_date',
    label: 'Enrollment Start Date',
    type: 'date',
    filterType: 'BETWEEN',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    isBasic: true,
  },
  {
    name: 'c_pap_enrollment_details_case__enrollment_end_date',
    label: 'Enrollment End Date',
    type: 'date',
    filterType: 'BETWEEN',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    isBasic: true,
  },
  {
    name: 'users__id',
    label: 'Assigned To',
    isDropdown: true,
    api_name: 'users',
    embedded_name: 'email',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'c_case_statuses__overall_case_status',
    label: 'Overall Status',
    isBasic: true,
    isDropdown: true,
    api_name: 'case_statuses',
    embedded_name: 'overall_case_status',
    uniqueValues: true,
  },
  {
    name: 'case_status_id',
    label: 'Stage Status',
    isDropdown: true,
    api_name: 'service_case_statuses',
    embedded_name: 'c_case_statuses.name,c_case_statuses,services',
    disabled: 'services__id',
    dependent: 'c_case_statuses__overall_case_status',
    filterBy: 'services.id,c_case_statuses.overall_case_status',
  },
  {
    name: 'intake_channel_id',
    label: 'Channel',
    isDropdown: true,
    api_name: componentNames.CATEGORY,
    embedded_name: 'Intake Channel',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'case_summary__outcome_id',
    label: 'Outcome',
    isDropdown: true,
    api_name: 'outcomes',
    filterType: filterOperatorValues.EQUALS,
    disabled: 'services__id',
    embedded_name: 'name,service,sub_service',
    filterBy: 'service.id,sub_service.name',
    dependent: 'c_sub_services__name',
  },
  {
    name: 'case_summary__outcome_reason_id',
    label: 'Outcome Reason',
    isDropdown: true,
    api_name: 'outcome_reasons',
    filterType: filterOperatorValues.EQUALS,
    disabled: 'case_summary__outcome_id',
    embedded_name: 'name,outcome',
    filterBy: 'outcome.id,outcome.service.id',
    payload: {
      payload: {
        entity_name: 'outcome_reasons',
        select: ['name', 'outcome'],
        page: 0,
        size: 50000,
        related_entities: {
          outcome: {
            select: ['sub_service', 'service'],
          },
        },
      },
    },
    dependent: 'services__id',
  },
  {
    name: 'created_at',
    label: 'Creation Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'case_start_date',
    label: 'Start Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'case_completion_date',
    label: 'Closed Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'modified_at',
    label: 'Last Updated Date',
    type: 'date',
    filterType: 'BETWEEN',
  },
  {
    name: 'modified_by',
    label: 'Last Updated By',
  },
  {
    name: 'legacy_id',
    label: 'Legacy ID',
  },
  {
    name: 'patient__first_name',
    label: 'Patient First Name',
  },
  {
    name: 'patient__last_name',
    label: 'Patient Last Name',
  },
  {
    name: 'patient__date_of_birth',
    label: 'Patient DOB',
    type: 'date',
  },
  {
    name: 'c_provider__first_name',
    label: 'Provider First Name',
  },
  {
    name: 'c_provider__last_name',
    label: 'Provider Last Name',
  },
  {
    name: 'c_provider__npi',
    label: 'Provider NPI',
  },
  {
    name: 'c_facilities__name',
    label: 'Healthcare Facility Name',
  },
  {
    name: 'c_facilities__c_facility_addresses_c_facilities__address_line_1',
    label: 'Healthcare Facility Address Line 1',
  },
  {
    name: 'patient__contact__first_name',
    label: 'Contact First Name',
  },
  {
    name: 'patient__contact__last_name',
    label: 'Contact Last Name',
  },
  {
    name: 'requestor__first_name',
    label: 'Requestor First Name',
  },
  {
    name: 'requestor__last_name',
    label: 'Requestor Last Name',
  },
  {
    name: 'c_case_insurances_c_cases__payer_id',
    label: 'Payer',
    isDropdown: true,
    api_name: 'payers',
    filterType: filterOperatorValues.EQUALS,
  },
]

const CaseViewFields: FieldDefinition<CaseViewFieldsType>[] = [
  {
    name: 'case_id',
    label: 'Case ID',
    isBasic: true,
  },
  {
    name: 'program',
    label: 'Program',
  },
  {
    name: 'product',
    label: 'Product',
    isDropdown: true,
    api_name: 'products',
    embedded_name: 'trademarked_name',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'channel',
    label: 'Channel',
    isDropdown: true,
    api_name: componentNames.CATEGORY,
    embedded_name: 'Intake Channel',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'case_type',
    label: 'Case Type',
    isDropdown: true,
    api_name: 'services',
    embedded_name: 'service_name',
    isBasic: true,
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'case_subtype',
    label: 'Case Subtype',
    isDropdown: true,
    api_name: 'sub_services',
    isBasic: true,
    filterType: filterOperatorValues.EQUALS,
    uniqueValues: true,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'enrollment_status__name',
    label: 'Enrollment Status',
    isDropdown: true,
    api_name: 'pap_enrollment_statuses',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    filterType: filterOperatorValues.EQUALS,
    isBasic: true,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'enrollment_start_date',
    label: 'Enrollment Start Date',
    type: 'date',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    isBasic: true,
  },
  {
    name: 'enrollment_end_date',
    label: 'Enrollment End Date',
    type: 'date',
    renderType: NAMESPACES.CONDITIONAL_KEY,
    isBasic: true,
  },
  {
    name: 'assignee',
    label: 'Assignee',
    isDropdown: true,
    api_name: 'users',
    embedded_name: 'email,first_name,last_name',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'overall_case_status',
    label: 'Overall Status',
    isBasic: true,
    isDropdown: true,
    api_name: 'case_statuses',
    embedded_name: 'overall_case_status',
    uniqueValues: true,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'case_status',
    label: 'Stage Status',
    isDropdown: true,
    api_name: 'service_case_statuses',
    embedded_name: 'c_case_statuses.name,c_case_statuses,services',
    disabled: 'case_type',
    filterBy: 'services.service_name,c_case_statuses.overall_case_status',
    dependent: 'overall_case_status',
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'outcome',
    label: 'Outcome',
    isDropdown: true,
    api_name: 'outcomes',
    filterType: filterOperatorValues.EQUALS,
    disabled: 'case_type',
    embedded_name: 'name,service,sub_service',
    filterBy: 'service.service_name,sub_service.name',
    dependent: 'case_subtype',
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'outcome_reason',
    label: 'Outcome Reason',
    isDropdown: true,
    api_name: 'outcome_reasons',
    filterType: filterOperatorValues.EQUALS,
    disabled: 'outcome',
    embedded_name: 'name,outcome',
    filterBy: 'outcome.name,outcome.service.service_name',
    payload: {
      payload: {
        entity_name: 'outcome_reasons',
        select: ['name', 'outcome'],
        page: 0,
        size: 50000,
        related_entities: {
          outcome: {
            select: ['sub_service', 'service'],
          },
        },
      },
    },
    dependent: 'case_type',
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'requestor_first_name',
    label: 'Requestor First Name',
  },
  {
    name: 'requestor_last_name',
    label: 'Requestor Last Name',
  },
  {
    name: 'requestor_phone_number',
    label: 'Requestor Phone Number',
  },
  {
    name: 'requestor_fax_number',
    label: 'Requestor Fax Number',
  },
  {
    name: 'patient_first_name',
    label: 'Patient First Name',
  },
  {
    name: 'patient_last_name',
    label: 'Patient Last Name',
  },
  {
    name: 'patient_dob',
    label: 'Patient DOB',
    type: 'date',
  },
  {
    name: 'patient_phone_number',
    label: 'Patient Phone Number',
  },
  {
    name: 'patient_fax_number',
    label: 'Patient Fax Number',
  },
  {
    name: 'provider_first_name',
    label: 'Provider First Name',
  },
  {
    name: 'provider_last_name',
    label: 'Provider Last Name',
  },
  {
    name: 'provider_phone_number',
    label: 'Provider Phone Number',
  },
  {
    name: 'provider_fax_number',
    label: 'Provider Fax Number',
  },
  {
    name: 'provider_npi',
    label: 'Provider NPI',
  },
  {
    name: 'healthcare_facility_name',
    label: 'Healthcare Facility Name',
  },
  {
    name: 'healthcare_facility_address_line_1',
    label: 'Healthcare Facility Address Line 1',
  },
  {
    name: 'healthcare_facility_phone_number',
    label: 'Healthcare Facility Phone Number',
  },
  {
    name: 'healthcare_facility_fax_number',
    label: 'Healthcare Facility Fax Number',
  },
  //TODO: Might need later
  // {
  //   name: 'payer',
  //   label: 'Payer',
  //   isDropdown: true,
  //   api_name: 'payers',
  //   filterType: filterOperatorValues.EQUALS,
  //   optionsBy: NAMESPACES.LABEL_KEY,
  // },
  {
    name: 'request_received_at',
    label: 'Request Received At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'case_start_date',
    label: 'Case Start Date',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'legacy_id',
    label: 'Legacy Id',
  },
  {
    name: 'created_at',
    label: 'Created At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'created_by',
    label: 'Created By',
  },
  {
    name: 'modified_at',
    label: 'Modified At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'modified_by',
    label: 'Modified By',
  },
]

const OrganizationFields: FieldDefinition<OrganizationFieldsType>[] = [
  {
    name: 'organization_key',
    label: 'Organization ID',
    isBasic: true,
  },
  {
    name: 'organization_sub_type__id',
    label: 'Organization Sub Type',
    isBasic: true,
    isDropdown: true,
    api_name: 'organization_sub_type',
    filterType: filterOperatorValues.EQUALS,
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'c_organization_phones_organization__phone_number',
    label: 'Phone/Fax Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'email',
    label: 'Email Address',
    isBasic: true,
  },
  {
    name: 'website',
    label: 'Website URL',
  },
  {
    name: 'npi',
    label: 'NPI number',
  },
  {
    name: 'tax_id',
    label: 'Tax ID',
  },
  {
    name: 'ncpdp',
    label: 'NCPDP number',
  },
  {
    name: 'external_id',
    label: 'External ID',
  },
  {
    name: 'legacy_id',
    label: 'Legacy ID',
  },
]

const FacilitiesViewFields: FieldDefinition<FacilitiesViewFieldsType>[] = [
  {
    name: 'Facility ID',
    label: 'Facility ID',
    isBasic: true,
  },
  {
    name: 'Facility Type',
    label: 'Facility Type',
    api_name: 'category',
    embedded_name: 'Facility Type',
    isDropdown: true,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'Facility Name',
    label: 'Name',
    isBasic: true,
  },
  {
    name: 'Phone Number',
    label: 'Phone Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isBasic: true,
  },
  {
    name: 'Fax Number',
    label: 'Fax Number',
    pattern: FORMAT_PATTERN.PHONE_INPUT,
    regex: REGEX.PHONE_INPUT,
    isPhone: true,
    isMultiLookup: true,
    isBasic: true,
  },
  {
    name: 'global_address_line_1',
    label: 'Address Line 1',
  },
  {
    name: 'global_address_line_2',
    label: 'Address Line 2',
  },
  {
    name: 'global_address_city',
    label: 'City',
  },
  {
    name: 'global_address_state',
    label: 'State',
    isDropdown: true,
    api_name: 'states',
    filterType: filterOperatorValues.EQUALS,
    optionsBy: NAMESPACES.LABEL_KEY,
  },
  {
    name: 'global_address_zip',
    label: 'Zip Code',
    isBasic: true,
    pattern: FORMAT_PATTERN.ZIP_CODE,
    regex: REGEX.ZIP_CODE,
  },
  {
    name: 'Email',
    label: 'Email Address',
  },
  {
    name: 'Website',
    label: 'Website URL',
  },
  {
    name: 'NPI',
    label: 'NPI Number',
    isBasic: true,
  },
  {
    name: 'Tax ID',
    label: 'Tax ID',
  },
  {
    name: 'NCPDP',
    label: 'NCPDP',
  },
  {
    name: 'External ID',
    label: 'External ID',
  },
  {
    name: 'Legacy ID',
    label: 'Legacy ID',
  },
  {
    name: 'created_at',
    label: 'Created At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'created_by',
    label: 'Created By',
  },
  {
    name: 'modified_at',
    label: 'Modified At',
    type: 'datetime-local',
    filterType: 'EQUALS',
  },
  {
    name: 'modified_by',
    label: 'Modified By',
  },
]

interface FieldDefinition<T> {
  name: keyof T
  label: string
  type?: string
  pattern?: string
  filterType?: string
  regex?: RegExp
  isPhone?: boolean
  isMultiLookup?: boolean
  isDropdown?: boolean
  api_name?: string
  embedded_name?: string
  isBasic?: boolean
  disabled?: keyof T
  filterBy?: string
  uniqueValues?: boolean
  optionsBy?: string
  renderType?: string
  payload?: GetEntityDataByNameIdFilter
  dependent?: keyof T
}

const getFields = (
  entityType: string,
  isIncomingCall?: boolean
):
  | FieldDefinition<ProviderFieldsType>[]
  | FieldDefinition<PatientFieldsType>[]
  | FieldDefinition<ContactFieldsType>[]
  | FieldDefinition<CaseFieldsType>[]
  | FieldDefinition<OrganizationFieldsType>[]
  | FieldDefinition<ProviderViewFieldsType>[]
  | FieldDefinition<CaseViewFieldsType>[]
  | FieldDefinition<PatientViewFieldsType>[]
  | FieldDefinition<FacilitiesViewFieldsType>[] => {
  if (entityType === 'Provider' || entityType === 'providers') {
    return isIncomingCall ? ProviderFields : ProviderViewFields
  } else if (entityType === 'Patient' || entityType === 'patients') {
    return isIncomingCall ? PatientFields : PatientViewFields
  } else if (entityType === 'Contact' || entityType === 'contacts') {
    return ContactFields
  } else if (entityType === 'Case' || entityType === 'case') {
    return isIncomingCall ? CaseFields : CaseViewFields
  } else if (entityType === 'Facility' || entityType === 'facilities') {
    return FacilitiesViewFields
  } else if (entityType === 'Organization' || entityType === 'organizations') {
    return OrganizationFields
  }
  return []
}
